import React, { useEffect, useRef, useState } from "react";
import { FaFilePdf, FaEdit, FaInfoCircle, FaFileAlt } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { User_Authentication } from "../../../user_authentication/User_Authentication";
import { Get_Order_Details } from "../../../api/category_product/Category_Product";
import Loader from "../../../loader/Loader";
import User_Dashbaord_Common_Section from "../../pages/user_dashboard/user_dashboard_common_section/User_Dashbaord_Common_Section";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettingData } from "../../../redux/actions/settingAction";
export default function InvoicePage() {
    const dispatch = useDispatch();

    const { id } = useParams()
    const [is_loading, set_Is_Loading] = useState(false)
    const [order_details, set_order_details] = useState({})
    const invoiceRef = useRef(null);
    const orderId = Number(atob(id));


    const order_list = order_details?.order?.order_details || [];
    const gstTotalAmount = order_list?.reduce((total, item) => {
        const unitgstAmount = Number(item.gst_amount)
        return total + unitgstAmount;
    }, 0) || 0;
    const { settingData } = useSelector(
        (state) => state?.settingdata || []
    );


    useEffect(() => {
        dispatch(fetchSettingData());
    }, [dispatch]);

    const invoice = {
        invoiceNo: order_details?.order?.orderNo,
        date: order_details?.order?.created_at.slice(0, 10),
        // dueDate: "2025-09-15",
        sender: {
            name: settingData[0]?.sitename || "Omens",
            address: settingData[0]?.address,
            email: settingData[0]?.email,
            phone: settingData[0]?.phone,
        },
        receiver: {
            name: order_details?.order?.user?.name,
            address: order_details?.order?.shipping_address,
            email: order_details?.order?.user?.email,
            phone: order_details?.order?.user?.mobileWithCountryCode,
        },
        products: order_details?.order?.order_details,
        shipping: order_details?.order?.shipping_cost,
        gstTotalAmount: gstTotalAmount,
        // discount: order_details?.order?.coupon_amount,
        total: order_details?.order?.final_amount,
        notes: "Thank you for doing business with us!",
        payment_type: order_details?.order?.payment_type,
        payment_status: order_details?.order?.payment_status,
    };


    useEffect(() => {
        const Handle_Get_Order_Details = async () => {
            set_Is_Loading(true);
            try {
                const token = User_Authentication();
                if (!token) {
                    set_Is_Loading(false);
                    throw new Error("User token not found");
                }
                // Pass `orderId` as a simple value
                const response = await Get_Order_Details(orderId, { Authorization: `Bearer ${token}` });

                if (response?.data?.status == "200") {
                    set_order_details(response?.data?.data);
                } else if (response?.response?.data?.status == "500") {
                    set_order_details(response?.data?.data);
                }
            } catch (error) {
                console.error("Error fetching order details:", error);
            } finally {
                set_Is_Loading(false);
            }
        };

        if (orderId) {
            Handle_Get_Order_Details();
        } else {
            console.error("Order ID is missing from the URL.");
        }
    }, [orderId]);

    const subtotal = invoice?.products?.reduce(
        (acc, item) => acc + item.quantity * item.base_price,
        0
    );

    const downloadInvoice = async () => {
        const input = invoiceRef.current;
        if (!input) return;

        const canvas = await html2canvas(input, { scale: 2, useCORS: true, allowTaint: false });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(`Invoice-${invoice.invoiceNo || "NA"}.pdf`);
    };




    return (
        <>
            <div>
                {/* <-------- Header section's ------------> */}
                <Header />
                {
                    is_loading ? (
                        <Loader />
                    ) : (
                        <div className="bg-[#f8f8f8] py-8">
                            <div
                                className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                <div className="myaccount-section w-full">
                                    <div className="w-full">
                                        <div className="w-full my-10">
                                            <div className="w-full bg-white shadow-xl p-5">
                                                <div className="my_account w-full flex space-x-10">
                                                    <User_Dashbaord_Common_Section />
                                                    <div className="min-h-screen bg-gray-100 p-8 flex flex-col items-center justify-center">
                                                        <div ref={invoiceRef} className="bg-white shadow-xl rounded-lg p-8 w-full max-w-4xl">
                                                            {/* Header */}
                                                            <div className="flex justify-between items-center border-b pb-4 mb-6">
                                                                <h1 className="text-3xl font-bold text-gray-800">INVOICE</h1>
                                                                <div className="text-right text-gray-600">
                                                                    <p className="font-semibold">Invoice #: {invoice.invoiceNo}</p>
                                                                    <p>Date: {invoice.date}</p>

                                                                </div>
                                                            </div>

                                                            {/* Sender & Receiver */}
                                                            <div className="grid grid-cols-2 gap-8 mb-6">
                                                                <div>
                                                                    <h2 className="text-lg font-semibold text-gray-700 mb-2">
                                                                        Billing To
                                                                    </h2>
                                                                    <h3 className="text-[14px] font-semibold">{invoice.sender.name}</h3>
                                                                    <p>{invoice.sender.address}</p>
                                                                    <p>{invoice.sender.email}</p>
                                                                    <p>{invoice.sender.phone}</p>
                                                                </div>
                                                                <div>
                                                                    <h2 className="text-lg font-semibold text-gray-700 mb-2">
                                                                        Shipped To
                                                                    </h2>
                                                                    <h3 className="text-[14px] font-semibold">{invoice.receiver.name}</h3>
                                                                    <p>{invoice.receiver.address}</p>
                                                                    <p>{invoice.receiver.email}</p>
                                                                    <p>{invoice.receiver.phone}</p>
                                                                </div>
                                                                <div>
                                                                    <p><b>Payment Type:</b> {invoice.payment_type}</p>
                                                                    <p><b>Payment Status:</b> {invoice.payment_status}</p>
                                                                </div>
                                                            </div>

                                                            {/* Items Table */}
                                                            <table className="w-full border-collapse mb-6">
                                                                <thead>
                                                                    <tr className="bg-gray-200 text-left text-gray-700 text-sm">
                                                                        <th className="p-2">Sr.No</th>
                                                                        <th className="p-2">Product Image</th>
                                                                        <th className="p-2">Product Name</th>
                                                                        <th className="p-2 text-right">Qty</th>
                                                                        <th className="p-2 text-right">Price</th>
                                                                        <th className="p-2 text-right">Total</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {invoice?.products?.map((item, idx) => (
                                                                        <tr key={idx} className="border-b hover:bg-gray-50 text-[12px]">
                                                                            <td className="p-2">{idx + 1}</td>

                                                                            <td className="p-2"><img src={`${process.env.REACT_APP_IMG_BASE_URL}${item?.product_image?.image_url}`} crossOrigin="anonymous" className="h-20 w-20" alt="" /></td>
                                                                            <td className="p-2">{item?.product?.name}</td>
                                                                            <td className="p-2 text-right">{item?.quantity}</td>
                                                                            <td className="p-2 text-right">₹{item?.base_price.toFixed(2)}</td>
                                                                            <td className="p-2 text-right">
                                                                                ₹{(item?.quantity * item?.base_price).toFixed(2)}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>

                                                            {/* Summary */}
                                                            <div className="flex justify-end mb-6">
                                                                <div className="w-64 space-y-2">
                                                                    <div className="flex justify-between text-sm">
                                                                        <span className="font-semibold">Price:</span>
                                                                        <span>₹{subtotal}</span>
                                                                    </div>

                                                                    {invoice?.shipping > 0 && (
                                                                        <div className="flex justify-between text-sm">
                                                                            <span className="font-semibold">Shipping:</span>
                                                                            <span>₹{invoice?.shipping}</span>
                                                                        </div>
                                                                    )}

                                                                    {invoice?.gstTotalAmount > 0 && (
                                                                        <div className="flex justify-between text-sm">
                                                                            <span className="font-semibold">Tax:</span>
                                                                            <span>₹{invoice?.gstTotalAmount}</span>
                                                                        </div>
                                                                    )}



                                                                    <div className="border-t pt-2 flex justify-between font-bold text-lg">
                                                                        <span>Total:</span>
                                                                        <span>₹{invoice.total}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Notes */}
                                                            {invoice.notes && (
                                                                <div className="bg-gray-50 p-4 rounded-lg text-gray-600 mb-6">
                                                                    <h3 className="font-semibold mb-1">Notes:</h3>
                                                                    <p>{invoice.notes}</p>
                                                                </div>
                                                            )}


                                                        </div>
                                                        {/* Actions */}
                                                        <div className="flex w-full justify-end gap-3 mt-2 no-print">
                                                            <button

                                                                className="flex gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm "
                                                                onClick={downloadInvoice}
                                                            >
                                                                <FaFilePdf className="text-sm" />
                                                                Print / Save PDF
                                                            </button>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                {/* <------- Footer section's ---------------> */}
                <Footer />
            </div>

        </>
    );
}
